import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 36 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M25.82 8H10.18A2.18 2.18 0 0 0 8 10.18v15.64A2.18 2.18 0 0 0 10.18 28h15.64A2.18 2.18 0 0 0 28 25.82V10.18A2.18 2.18 0 0 0 25.82 8ZM13 8v20M23 8v20M8 18h20M8 13h5M8 23h5M23 23h5M23 13h5",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }